import { ReactNode, useState } from 'react';
import { Navigate } from 'react-router-dom';
import classNames from 'classnames';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { NavSide, IconButton } from '../../components/base';
import AipMonitoring from './aip/AipMonitoring';
import '../../assets/styles/global.scss';

const isAdmin = (role?: string) => role === 'Admin';

// 대시보드 메뉴 항목 (이 파일에서만 사용)
interface DashboardMenuItem {
  id: string; // NavSide 활성/선택 키
  label: string; // 메뉴 표시명
  content: ReactNode; // 우측에 렌더할 콘텐츠(페이지 컴포넌트)
}

// 대시보드 메뉴 목록
const menuList: DashboardMenuItem[] = [
  { id: 'aip', label: 'AIP 문서 모니터링', content: <AipMonitoring /> },
  // { id: '...', label: '...', content: <... /> },  ← 추후 메뉴 추가
];

const DashboardLayout = () => {
  const { user } = useAppSelector((state: RootState) => state.users);
  const [currentId, setCurrentId] = useState<string>(menuList[0].id);
  const [collapsed, setCollapsed] = useState(false);

  if (!user?.userId) return null;

  // role이 'Admin'이 아니면 채팅 메인으로 돌려보낸다.
  if (!isAdmin(user.role)) return <Navigate to="/" replace />;

  const current = menuList.find((m) => m.id === currentId) ?? menuList[0];

  // NavSide용 메뉴 아이템 (id/label)
  const navItems = menuList.map((m) => ({ id: m.id, label: m.label, href: '' }));

  return (
    <div className={classNames('dashboard-layout', { 'is-collapsed': collapsed })}>
      <aside className="dashboard-side">
        <div className="dashboard-side-inner">
          <NavSide
            menuName="대시보드"
            menuItems={navItems}
            initialActiveMenu={currentId}
            onClick={(item) => {
              setCurrentId(String(item.id));
            }}
          />
        </div>
      </aside>

      {/* 메뉴 접기/펼치기 토글 (레이아웃 레벨) */}
      <IconButton
        className="dashboard-toggle"
        name={collapsed ? 'chevron' : 'chevronLeft'}
        size="small"
        onClick={() => {
          setCollapsed((v) => !v);
        }}
      >
        {collapsed ? '메뉴 열기' : '메뉴 닫기'}
      </IconButton>

      <main className="dashboard-content">{current.content}</main>
    </div>
  );
};

export default DashboardLayout;
